
import React from "react";
import { Box, Typography, Container } from "@mui/material";
import partnersImage from "../../assets/partners.png";

const PartnersSection: React.FC = () => {
    // Show on all screens for now, or match specific requirements
    // const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    // if (!isSmallScreen) return null;

    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "#fff", // White background
                py: 2,
                mt: 2,
                mb: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center"
            }}
        >
            <Container maxWidth="sm">
                <Typography
                    sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#000",
                        mb: 2,
                        fontFamily: "General-Sans-medium, sans-serif"
                    }}
                >
                    Recognized as safe to use by:
                </Typography>
                <Box
                    component="img"
                    src={partnersImage}
                    alt="Recognized as safe by Microsoft, McAfee, Avast, Kaspersky"
                    sx={{
                        width: "100%",
                        maxWidth: "350px", // Limit max width
                        height: "auto",
                        objectFit: "contain"
                    }}
                />
            </Container>
        </Box>
    );
};

export default PartnersSection;
